import React from 'react';
import {
	OrderList,
} from '../../components/StyledComponents';
import { Page } from '../../components/ui/Page'
import { ErrorMessage } from '../../components/ui/ErrorMessage';
import { Body } from '../../components/layout/Body';
import Store from '../../store/Store';

const modes: Record<string, string> = {
	map: 'Standort Suche',
	agric: 'Landwirtschaft',
	survey: 'Vermessung',
	cloud: 'Punktwolken',
	ndvi: 'NDVI',
};

export interface SearchOrdersProps {
	id?: string;
}

export default function SearchOrders(props: SearchOrdersProps) {
	const [searchOrdersError, searchOrders, searchMode] = (
		Store.use as (a: string, b: string, c: string) => [unknown, Parameters<typeof OrderList>[0]['orders'], string]
	)('searchOrdersError', 'searchOrders', 'searchMode');

	return (
		<Page>
			<Body title={modes[searchMode] ?? 'Suche'}>
				<OrderList title="Aufträge" orders={searchOrders ?? []} />
				<ErrorMessage>{String(searchOrdersError ?? '')}</ErrorMessage>
			</Body>
		</Page>
	);
}
